function maskValue(value) {
    const stringValue = String(value || "").trim();

    if (!stringValue) {
        return null;
    }

    if (stringValue.includes("@")) {
        const [localPart, domain] = stringValue.split("@");
        const preview = localPart.length <= 2 ? `${localPart[0] || ""}*` : `${localPart.slice(0, 2)}***`;
        return `${preview}@${domain}`;
    }

    const digitsOnly = stringValue.replace(/\D/g, "");
    if (digitsOnly.length >= 4) {
        return `***${digitsOnly.slice(-4)}`;
    }

    return "***";
}

function buildPayload(payload = {}) {
    return Object.fromEntries(
        Object.entries(payload)
            .map(([key, value]) => {
                if (key.toLowerCase().includes("email")) {
                    return [key, maskValue(value)];
                }

                if (key.toLowerCase().includes("phone")) {
                    return [key, maskValue(value)];
                }

                return [key, value];
            })
            .filter(([, value]) => value !== undefined && value !== null && value !== "")
    );
}

export function logAuthFlowInfo(eventType, payload = {}) {
    if (process.env.NODE_ENV !== "production") {
        console.info(`[auth-flow] ${eventType}`, buildPayload(payload));
    }
}

export function logAuthFlowWarning(eventType, payload = {}) {
    console.warn(`[auth-flow] ${eventType}`, buildPayload(payload));
}
